import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AIAgentsDashboard from './pages/ai-agents-dashboard';
import LoginPage from './pages/login';
import AppearanceCustomization from './pages/appearance-customization';
import AgentConfiguration from './pages/agent-configuration';
import RegisterPage from './pages/register';
import ProfilePage from './pages/profile';
import UserManagementSettings from './pages/user-management-settings';
import Settings from './pages/settings';
import EmbedChatWidget from './pages/embed-chat';
import GermanChatbot from './pages/german-chatbot';

const Routes = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<AgentConfiguration />} />
          <Route path="/ai-agents-dashboard" element={<AIAgentsDashboard />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/appearance-customization" element={<AppearanceCustomization />} />
          <Route path="/agent-configuration" element={<AgentConfiguration />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/user-management-settings" element={<UserManagementSettings />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/embed/:agentId" element={<EmbedChatWidget />} />
          <Route path="/chat/:agentId" element={<EmbedChatWidget />} />
          <Route path="/german-chatbot" element={<GermanChatbot />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Routes;